import moment from "moment";
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";

import { Card, PageHeader } from "@cofano/cck";
import { Box, Typography } from "@mui/material";

import useLayout from "components/layout/useLayout";
import Helmet from "components/helmet/Helmet";

import { Language } from "imports/Utils";

import ProductsNstrTable from "view/products/components/table/ProductsNstrTable";
import ProductNstrDetails from "view/products/components/details/ProductNstrDetails";

import { GetNstrProductListDocument } from "__generated__/view/products/graphql/product.queries.generated";
import { NstrGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

const ProductsNstr = () => {

	const { data, loading }  = useQuery(GetNstrProductListDocument);

	const layout = useLayout();

	const handleRowClick = (row: NstrGoodFragment) => {
		layout.setDrawerSettings({
			open: true,
			title: intl.formatMessage({ id: "PRODUCT" }),
			content: (
				<Box p={2}>
					<ProductNstrDetails nstrGood={row} />
				</Box>
			),
			size: "normal",
			variant: "overlay",
		});
	};

	return (
		<div className="nstr-container">
			<PageHeader>
				<PageHeader.Title>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
						{Language("PRODUCT_NSTR")}

						{data?.nstrProductList?.publicationDate && (
							<Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
								<Typography variant="caption" sx={{ lineHeight: 1, fontWeight: 600 }}>
									{Language("PRODUCT_IDTF_PUBLICATION")}:
								</Typography>

								<Typography variant="caption" sx={{ lineHeight: 1, fontWeight: 600 }}>
									{moment(data?.nstrProductList?.publicationDate).format("L")}
								</Typography>
							</Box>
						)}
					</Box>

					<Helmet title={intl.formatMessage({ id: "PRODUCT_NSTR" })} />
				</PageHeader.Title>
			</PageHeader>

			<Card disablePadding>
				<ProductsNstrTable
					content={data?.nstrProductList?.goods || []}
					contentLoading={loading}
					onRowClick={handleRowClick} />
			</Card>
		</div>
	);
};

export default ProductsNstr;
